import './QuestionList.css';

function QuestionList({ questions, onQuestionClick }) {
    const handleClick = ({ target }) => {
        onQuestionClick(target.textContent);
        target.remove();
    }

    return(
        <div>
            {questions.map((question, index) => {
                return (<div onClick={handleClick} className="question" key={index} style={{"borderColor": "pink"}}>
                    {question}
                </div>)
            })}
        </div>
    )
}

export default QuestionList;